import React, { useCallback, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { FlightDropdownOption } from 'components/Flights/types'
import { fareTypes, fareCabins } from 'constants/flight'
import { StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/SearchWidget'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import LocationInput from './LocationInput/LocationInput'
import TravellerInput from './TravellerInput/TravellerInput'
import FareDropdownMobile from './FareDropdown/FareDropdownMobile'
import DateSelectInput from './DateSelectInput/DateSelectInput'
import TextButton from 'components/Luxkit/Button/TextButton'

const Root = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${rem(12)};
  }
`

const LocationSelect = styled(LocationInput)`
  border-radius: ${props => props.theme.borderRadius.medium};
`

const Faredropdowns = styled.div`
  display: flex;
`

const FareTypeDropdown = styled(FareDropdownMobile)`
  > button {
    border-right: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
`

const CabinTypeDropdown = styled(FareDropdownMobile)`
  > button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`

interface Props {
  onSearchAirport: () => void;
  useMobileForm?: boolean;
}

function FlightSearchWidgetMobile(props: Props) {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { onSearchAirport, useMobileForm } = props
  const {
    fareType,
    fareCabin,
    departureAirport,
    arrivalAirport,
    activeMenu,
    showDepartureError,
    showDesinationError,
    checkinDate,
    checkoutDate,
  } = state

  const changeFareType = useCallback((fareType: FlightDropdownOption) => {
    dispatch({ type: FlightSearchWidgetActions.SET_FARE_TYPE, fareType })
  }, [dispatch])

  const changeFareCabin = useCallback((fareCabin: FlightDropdownOption) => {
    dispatch({ type: FlightSearchWidgetActions.SET_FARE_CABIN, fareCabin })
  }, [dispatch])

  const setActiveMenu = useCallback((activeMenu: StandaloneFlightMenu) => {
    dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu })
  }, [dispatch])

  // TODO: Temporary logic until migrate SearchV2 to desktop
  useEffect(() => {
    if (departureAirport && arrivalAirport && checkinDate && checkoutDate) {
      onSearchAirport()
    }
  }, [departureAirport, arrivalAirport, checkinDate, checkoutDate, onSearchAirport])

  return (
    <Root>
      <LocationSelect
        useOnlyMobile={useMobileForm}
        isDeparture
        title="From"
        airport={departureAirport}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        showDepartureError={showDepartureError}
      />
      <LocationSelect
        useOnlyMobile={useMobileForm}
        isDeparture={false}
        title="To"
        airport={arrivalAirport}
        activeMenu={activeMenu}
        setActiveMenu={setActiveMenu}
        showDesinationError={showDesinationError}
      />
      <DateSelectInput useOnlyMobile={useMobileForm} />
      <TravellerInput useOnlyMobile={useMobileForm} />
      <Faredropdowns>
        <FareTypeDropdown
          options={fareTypes}
          title="Flight type"
          selectedOption={fareType}
          onOptionChange={changeFareType}
        />
        <CabinTypeDropdown
          options={fareCabins}
          title="Class"
          selectedOption={fareCabin}
          onOptionChange={changeFareCabin}
        />
      </Faredropdowns>
      <TextButton kind="primary" size="large" onClick={onSearchAirport}>
        Search
      </TextButton>
    </Root>
  )
}

export default FlightSearchWidgetMobile
